export default __webpack_public_path__ + "static/media/nepal2015A.a45a4cf8.jpg";